// import { rolesConfig } from "../rolesConfig";
import { useRole } from "../../context/RoleContext";

const ProtectedButton = ({ page, action, children }) => {
  const { role, rolesConfig } = useRole();
  const rolePermissions = rolesConfig[role]?.pages[page];

  if (!rolePermissions) return null;
 
  const actions = Array.isArray(action) ? action : [action];
 
  const hasPermission = actions.some((act) =>
    rolePermissions.includes(act)
  );

  if (hasPermission) {
    return children;
  }

  return null;
};

export default ProtectedButton;
